import MyImage from 'components/MyImage';
import { memo } from 'react'
import RockAdImage from 'assets/images/ads1.png'
import { HStack } from 'components/Stack';


const _Banner = () => {
    return <div>
        <a href='https://rocktoyou.com?l=d0t32qcm'>
            <HStack>
                <MyImage src={RockAdImage} maxWidth={'390px'} alt='돌굴러가유' />
                <MyImage src={RockAdImage} maxWidth={'390px'} alt='돌굴러가유' />
            </HStack>
        </a>
    </div>
}

export const Banner = memo(_Banner);